/**
 * Quién es «véltica» en los documentos legales, escrito UNA vez.
 *
 * Cuando exista una empresa, se cambia aquí y en ningún documento más: todos
 * leen estos valores a través de marcadores (`{operator}`, `{email}`…).
 *
 * `OPERATOR` es hoy una persona física. Al constituir una sociedad, cambia el
 * nombre y, si procede, la sede de los tribunales.
 */
import { BETA_MONTHS, BETA_OFF_PERCENT } from '../lib/planPricing'
import { PLAN_LABEL, PLATFORM_FEE_PERCENT } from '@webbuilder/plans'

export const LEGAL_ENTITY = {
  /** La parte contratante frente a los clientes. */
  operator: 'Heriberto Murrieta',
  /** Dónde está establecido, sin calle: los documentos sólo necesitan la ciudad. */
  location: 'San Diego, California, EE. UU.',
  locationEn: 'San Diego, California, USA',
  /** El único buzón que reciben soporte, privacidad, derechos de autor y avisos. */
  email: 'info@veltica.com',
  /** Condado cuyos tribunales resuelven las disputas. */
  venueCounty: 'San Diego',
} as const

/** Cuándo entró en vigor esta versión de TODOS los documentos. */
export const LEGAL_EFFECTIVE = {
  es: '17 de octubre de 2026',
  en: 'October 17, 2026',
  version: '1.1',
} as const

/**
 * Los valores que los documentos citan y que NO se escriben a mano: si el
 * servidor cobra otra comisión o la beta cambia de descuento, los términos
 * cambian solos y no dicen una cosa mientras se cobra otra.
 */
export function legalPlaceholders(language: 'es' | 'en'): Record<string, string> {
  return {
    operator: LEGAL_ENTITY.operator,
    location: language === 'es' ? LEGAL_ENTITY.location : LEGAL_ENTITY.locationEn,
    email: LEGAL_ENTITY.email,
    county: LEGAL_ENTITY.venueCounty,
    effective: LEGAL_EFFECTIVE[language],
    planStarter: PLAN_LABEL.free,
    planPro: PLAN_LABEL.pro,
    planBusiness: PLAN_LABEL.business,
    feeStarter: String(PLATFORM_FEE_PERCENT.free),
    feePro: String(PLATFORM_FEE_PERCENT.pro),
    feeBusiness: String(PLATFORM_FEE_PERCENT.business),
    betaPercent: String(BETA_OFF_PERCENT),
    betaMonths: String(BETA_MONTHS),
  }
}
